/* unplugin-vue-components disabled */import { render } from "./tools.vue?vue&type=template&id=63c154f0&scoped=true"
import script from "./tools.vue?vue&type=script&lang=js"
export * from "./tools.vue?vue&type=script&lang=js"

import "./tools.vue?vue&type=style&index=0&id=63c154f0&lang=scss&scoped=true"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c154f0"]])

export default __exports__